import { TYPES } from "./staff.type";

const initState = {
  staffs: null,
  active: null,
  search: null,
  infos: null,
  detail: null,
  infoDetail: null,
  staffList: null,
  all: null,
};

const staffReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.GET_STAFF_ACTIVE_SUCCESS:
      return {
        ...state,
        active: payload,
      };

    case TYPES.GET_STAFFS_SUCCESS:
      return {
        ...state,
        staffs: payload,
      };
    case TYPES.GET_STAFFS_INFO_SUCCESS:
      return {
        ...state,
        infos: payload,
      };
    case TYPES.GET_SEARCH_SUCCESS:
      return {
        ...state,
        search: payload,
      };
    case TYPES.SELECT_DETAIL_STAFF_SUCCESS:
      return {
        ...state,
        detail: payload,
      };
    case TYPES.SELECT_DETAIL_INFO_STAFF_SUCCESS:
      return {
        ...state,
        infoDetail: payload,
      };
    case TYPES.GET_STAFF_SUCCESS:
      return {
        ...state,
        staffList: payload,
      };
    case TYPES.SNAP_ALL_STAFF_SUCCESS:
      return {
        ...state,
        all: payload,
      };
    default:
      return state;
  }
};

export default staffReducer;
